import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API} = extractAPIValues()

//房间添加语音包
export function addRoomLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/room/add'
  return axiosPostHandler(url, args, formdata)
}

//房间上传语音包
//path ext name room_id
export function uploadRoomLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/room/upload'
  return axiosPostHandler(url, args, formdata)
}

//房间删除语音包
//room_id path
export function deleteRoomLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/room/del'
  return axiosPostHandler(url, args,formdata)
}

//房间修改语音包名称
//room_id path name
export function modifyRoomLaughterName(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/room/edit'
  return axiosPostHandler(url, args,formdata)
}

//获取房间语音包
export function getRoomLaughter(args) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/room/list'
  return axiosGetHandler(url, args)
}

//获取用户语音包列表
export function getUserLaughterTracks(args) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/user/list'
  return axiosGetHandler(url, args)
}

//用户删除语音包
export function deleteUserLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/user/del'
  return axiosPostHandler(url, args, formdata)
}

//用户上传语音包
export function uploadUserLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/user/upload'
  return axiosPostHandler(url, args,formdata)
}

//用户添加语音包
export function addUserLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/user/add'
  return axiosPostHandler(url, args, formdata)
}

//用户修改语音包名称
export function modifyUserLaughterName(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/user/edit'
  return axiosPostHandler(url, args, formdata)
}


//用户置顶语音包
export function topUserLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/user/top'
  return axiosPostHandler(url, args,formdata)
}

//发送语音包
// room_id,channel_id,path,name,ext,volume,
export function sendSoundMessage(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/user/send'
  return axiosPostHandler(url, args, formdata)
}

// 获取语音包平台列表
export function getPlatformVoice(args) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/platform/list'
  return axiosGetHandler(url, args)
}

// 上传到语音包平台
export function uploadPlatformLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/platform/upload'
  return axiosPostHandler(url, args, formdata)
}

// 获取我的语音包平台列表
export function getMyPlatformVoice(args) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/mine/list'
  return axiosGetHandler(url, args)
}

// 上架到语音包平台
export function putawayPlatformLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/mine/set'
  return axiosPostHandler(url, args, formdata)
}

// 从语音包平台下架
export function soldoutPlatformLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/mine/unset'
  return axiosPostHandler(url, args, formdata)
}

// 公开我的语音包
export function openMyLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/mine/publish'
  return axiosPostHandler(url, args, formdata)
}

// 获取有权限添加语音包的房间
export function getVoiceRoomList(args) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/user/rooms'
  return axiosGetHandler(url, args)
}

// 语音包调整顺序
export function sortVoicePack(args, formdata){
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/user/sort'
  return axiosPostHandler(url, args, formdata)
}

export function deletePlatformLaughter(args, formdata) {
  let url = BASE_API + '/chatroom/v2/msg/voice_pack/mine/delete'
  return axiosPostHandler(url, args, formdata)
}